import { AXIOS_INSTANCE } from "..";
import { CASINO_SERVICE_URL, getToken } from "../../utils/constants";

export const getCasinoReportHistory = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/casino/casino-report-history`,
      {
        ...payload,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getIndividualResultAPI = async (marketId) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/casino/individaul-result?marketId=${marketId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const casinoReportHistoryAPI = async (payload) => {
  try {
    const { data } = await AXIOS_INSTANCE.post(
      `${CASINO_SERVICE_URL}/casino-report-history`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getIndividualResultCasinoAPI = async (marketId, casinoGame) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/individaul-result`,
      {
        params: {
          marketId: marketId,
          casinoGame,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getUniversalCasinoBetsAPI = async (casinoGames) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/admin/client-bets`,
      {
        params: {
          betStatus: "MATCHED",
          casinoGames,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getCasinoExposureAPI = async (marketId) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/pl-exposure`,
      {
        params: {
          marketId: marketId,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getUniversalCasinoOddsAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/uni-odds`,
      {
        params: {
          casinoGames: game,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getUniversalCasinoLastResultAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/uni-last-10-results`,
      {
        params: {
          casinoGames: game,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const getCasinoLastTenResultAPI = async (game) => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${CASINO_SERVICE_URL}/last-10-results`,
      {
        params: {
          casinoGames: game,
        },
      }
    );
    return data;
  } catch (error) {
    return error;
  }
};